// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU'
export const WINDOW_WIDTH = 'WINDOW-WIDTH'
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE'


//Contact Module const
export const UPDATE_PASS = 'UPDATE_PASS'
export const DELETE_ORDER = 'DELETE_ORDER'
export const BILL_INFO = 'BILL_INFO'
export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const HIDE_MESSAGE = 'HIDE_MESSAGE'
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER'
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER'
export const CREATE_NOTIFICATION= 'CREATE_NOTIFICATION'
export const SHOW_DETAILS = 'SHOW_DETAILS'
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const CREATE_PRODUCT = 'CREATE_PRODUCT'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'

export const FETCH_ORDER = 'FETCH_ORDER'
export const FETCH_ALLORDERS = 'FETCH_ALLORDERS'
export const FETCH_ORDER_DATE='FETCH_ORDER_DATE'
export const UPDATE_ORDER__DELIVERY_STATUS ='UPDATE_ORDER__DELIVERY_STATUS'
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const UPDATE_ORDER_STATUS ='UPDATE_ORDER_STATUS'
//Auth const
export const UPDATE_STATUS_USER = 'UPDATE_STATUS_USER'
export const UPDATE_STATUS_PRODUCT = 'UPDATE_STATUS_PRODUCT'

export const FETCH_ALL_NOTIFICATIONS = 'FETCH_ALL_NOTIFICATIONS'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
export const UPDATE_STATUS_NOTIFICATION = 'UPDATE_STATUS_NOTIFICATION'
export const SIGNUP_USER = 'SIGNUP_USER'
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS'
export const SIGNIN_USER = 'SIGNIN_USER'
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS'
export const SIGNOUT_USER = 'SIGNOUT_USER'
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS'
export const INIT_URL = 'INIT_URL'
export const FETCH_COUPONS = 'FETCH_COUPONS'
export const FETCH_COUPON = 'FETCH_COUPON'
export const FETCH_STORES = 'FETCH_STORES'
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_VENDORS = 'FETCH_VENDORS'
export const CREATE_COUPON = 'CREATE_COUPON'
export const CREATE_VENDOR = 'CREATE_VENDOR'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_STORE = 'CREATE_STORE'
export const UPDATE_COUPON = 'UPDATE_COUPON'
export const DELETE_COUPON = 'DELETE_COUPON'
export const FETCH_STORE_COUPON = 'FETCH_STORE_COUPON'
export const FETCH_ONE_COUPON = 'FETCH_ONE_COUPON'
export const UPDATE_STORE = 'UPDATE_STORE'
export const DELETE_STORE = 'DELETE_STORE'
export const CLEAR_ONE_COUPON = 'CLEAR_ONE_COUPON'
export const REDEMPTION_COUPON = 'REDEMPTION_COUPON'
export const DELETE_REDEMPTION_COUPON = 'DELTE_REDEMPTION_COUPON'
export const UPDATE_VENDOR = 'UPDATE_VENDOR'
export const DELETE_VENDOR = 'DELETE_VENDOR'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'
export const CREATE_COUPON_IMAGE = 'CREATE_COUPON_IMAGE'
export const FETCH_COUPON_DATA = 'FETCH_COUPON_DATA'
export const EDIT_COUPON_IMAGE = 'EDIT_COUPON_IMAGE'
export const CREATE_STORE_IMAGE = 'CREATE_STORE_IMAGE'
export const EDIT_STORE_IMAGE = 'EDIT_STORE_IMAGE'
export const FETCH_BAR_CATEGORY = 'FETCH_BAR_CATEGORY'
export const CREATE_CATEGORY_IMAGE = 'CREATE_CATEGORY_IMAGE'
export const EDIT_CATEGORY_IMAGE = 'EDIT_CATEGORY_IMAGE'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const FETCH_COMPANIES = 'fetch_companies'
export const FETCH_REPORT_BALANCE = 'fetch_report_balance'
export const FETCH_DATA_COMPANIES = 'fetch_data_companies'

export const FETCH_AVAIALABLE_COUPONS='FETCH_AVAIALABLE_COUPONS'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js